import { DateTime } from 'luxon'

import { Language } from '@/core/api/dtos/common/language'

export class BusinessCategory {
	public id: number
	public parentId: number | null
	public key: string
	public name: string
	public nameTranslations?: Language
	public requiresDescription: boolean
	public tags?: string[]
	public createdAt?: DateTime
	public updatedAt?: DateTime
	public parent?: BusinessCategory

	constructor({
		id,
		parentId,
		key,
		name,
		nameTranslations,
		requiresDescription,
		tags,
		createdAt,
		updatedAt,
		parent,
	}: {
		id: number
		parentId: number | null
		key: string
		name: string
		nameTranslations?: Language
		requiresDescription: boolean
		tags?: string[]
		createdAt?: DateTime
		updatedAt?: DateTime
		parent?: BusinessCategory
	}) {
		this.id = id
		this.parentId = parentId
		this.key = key
		this.name = name
		this.nameTranslations = nameTranslations
		this.requiresDescription = requiresDescription
		this.tags = tags
		this.createdAt = createdAt
		this.updatedAt = updatedAt
		this.parent = parent
	}

	// Factory method for creating from partial data (safer than using Object.assign directly)
	static create(partial: Partial<BusinessCategory>): BusinessCategory {
		// Set sensible defaults for missing properties
		const defaults = {
			id: 0,
			parentId: null,
			key: '',
			name: '',
			nameTranslations: {},
			requiresDescription: false,
			tags: undefined,
			createdAt: DateTime.now(),
			updatedAt: DateTime.now(),
			parent: undefined,
		}

		return new BusinessCategory({ ...defaults, ...partial })
	}
}
